import USER_MEDIA from "@/lib/user-media";
export default {
  name: "p-async-permission-media",
  props: {
    theme: {
      type: String,
      default: "light"
    },
    constraints: {
      type: Object,
      default() {
        return {
          video: true
        };
      }
    }
  },
  data() {
    return {
      permission: false,
      message: "",
      error: null
    };
  },
  computed: {
    compTheme() {
      if (this.theme === "light") {
        return ["bg-light", "text-dark"].join(" ");
      } else {
        return ["bg-dark", "text-light"].join(" ");
      }
    }
  },
  methods: {
    async asyncPermissionToUseUserMedia(constraints) {
      return USER_MEDIA.asyncPermissionToUseUserMedia(constraints).then(permission => {
        if (permission instanceof Error) {
          return Promise.reject(permission);
        } else {
          this.permission = true;
          this.message = "カメラの使用が許可されました。";
          this.error = null;
        }
      }).catch(err => {
        this.permission = false;
        this.message = "カメラの使用が拒否されています";
        this.error = err;
      });
    }
  },
  async created() {
    await this.asyncPermissionToUseUserMedia(this.constraints);
  }
};